/**************************************************
 * Nombre:       Home_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, IconButton} from "@mui/material";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import '@splidejs/react-splide/css';
import Tarjeta_Banner from "../../Tarjetas/Tarjeta_Banner";
import {useContext, useEffect, useRef, useState} from "react";
import {contexApp} from "../../../App";
import fondo from '../../../Recursos/fondos.png'
import foto from "../../../Recursos/Temporales/foto_banner.png"
import {KeyboardArrowLeft, KeyboardArrowRight} from '@mui/icons-material'

const Home_Portada = () => {
    const cData = useContext(contexApp)
    const refe = useRef()
    const [anuncios, setAnuncios] = useState([]);


    const siguiente = () => {
        refe.current.go('>')
    }

    const atras = () => {
        refe.current.go('<')
    }

    useEffect(() => {

        if (cData.anuncios) {
            setAnuncios(cData.anuncios);
        }

    }, [cData])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                mt: -12,
                backgroundImage: `url(${fondo})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
            }}
        >


            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 11}}
                >


                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                        <Splide
                            ref={refe}
                            aria-label="My Favorite Images" style={{width: '100%'}}
                            options={{
                                autoplay: true,
                                speed: 1500,
                                rewind: true,
                                perPage: 1,
                                arrows: false,
                                pagination: true,
                                width: '100%',
                                drag: false,
                                interval: 8000,
                                noDrag: true,
                                type: 'loop',
                            }}
                        >

                            {banners.map((item, index) => {
                                return (
                                    <SplideSlide key={`qe${index}`}>
                                        <Tarjeta_Banner item={item} siguiente={siguiente} atra={atras}/>
                                    </SplideSlide>
                                )
                            })}


                        </Splide>


                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'flex-start', px: 3, mt: -10, mb: 0}}
                          spacing={2}
                    >
                        <IconButton
                            onClick={() => atras()}
                            sx={{border: 2, borderColor: '#fff'}}>
                            <KeyboardArrowLeft sx={{fill: '#fff'}}/>
                        </IconButton>

                        <IconButton
                            onClick={() => siguiente()}
                            sx={{border: 2, borderColor: '#fff'}}>
                            <KeyboardArrowRight sx={{fill: '#fff'}}/>
                        </IconButton>

                    </Grid>

                </Grid>

            </Grid>


        </Grid>
    )

}
export default Home_Portada

const banners = [
    {
        nombre: 'Fórmate como técnico, triunfa como profesional',
        descripcion: 'En CESSA te certificamos con metodologías innovadoras para una empleabilidad inmediata en la región. Gracias a nuestros convenios, inicias hoy tu técnica y aseguras tu futuro con proyección universitaria',
        img: foto,
        textoBoton: 'Mas Informacion',

    },
    {
        nombre: 'Fórmate como técnico, triunfa como profesional',
        descripcion: 'En CESSA te certificamos con metodologías innovadoras para una empleabilidad inmediata en la región. Gracias a nuestros convenios, inicias hoy tu técnica y aseguras tu futuro con proyección universitaria',
        img: foto,
        textoBoton: 'Mas Informacion',

    },
]